import { FormikProps } from "formik";
import { RosTemplate } from "../../../../../../../services";
import { Grid } from "@mui/material";
import MaskMultiSelect from "../../../../../../../components/MaskMultiSelect";
import { useDebounce } from "../../../../../../../hooks/use-debounce";
import { DEF_PAGINATION } from "../../../../../../../utils/utils";
import { useMemo } from "react";
import { useGetCataLogCode } from "../../../../../../../queries/catalog/use-get-catalog-code";
import CustomTextArea from "../../../../../../../components/CustomTextArea";

interface CarePlanFormProps {
  formik: FormikProps<RosTemplate>;
  disabled?: boolean;
}

const CarePlanForm = ({ formik, disabled = false }: CarePlanFormProps) => {
  // console.log("formik.values ", formik.values);
  const [searchIcdKey, setSearchIcdKey] = useDebounce<string>("");

  const { data: icdCodes } = useGetCataLogCode({
    pagination: DEF_PAGINATION,
    searchKey: searchIcdKey,
    type: "ICD",
    active: undefined,
    archive: false,
  });
  const transFormedIcdCodes = useMemo(
    () =>
      icdCodes?.data?.content?.map((it) => ({
        value: it?.uuid,
        label: `${it?.code} - ${it?.description || ""}`,
      })),
    [icdCodes]
  );

  return (
    <Grid
      container
      spacing={1}
      sx={{
        gap: 1,
      }}
    >
      <Grid size={12}>
        <MaskMultiSelect
          disabled={disabled}
          placeholder="Search & Select ICD Codes"
          value={(formik.values?.icdCodes as any) ?? undefined}
          onSearch={setSearchIcdKey}
          options={transFormedIcdCodes}
          onChange={(v) => formik.setFieldValue("icdCodes", v)}
        />
      </Grid>
      <Grid size={12}>
        <CustomTextArea
          disabled={disabled}
          label="Goals"
          placeholder="Enter Goals"
          name="goals"
          value={formik.values.goals}
          onChange={formik.handleChange}
          minRows={2}
        />
      </Grid>
      <Grid size={12}>
        <CustomTextArea
          disabled={disabled}
          label="Intervention & Tasks"
          placeholder="Enter Interventions & Tasks"
          name="intervention"
          value={formik.values.intervention}
          onChange={formik.handleChange}
          minRows={2}
        />
      </Grid>
      <Grid size={12}>
        <CustomTextArea
          disabled={disabled}
          label="Preventive Schedule"
          placeholder="Enter Information about upcoming diagnosis test, immunization & follow-up visit"
          name="preventive_schedule"
          value={formik.values.preventive_schedule}
          onChange={formik.handleChange}
          minRows={2}
        />
      </Grid>
    </Grid>
  );
};

export default CarePlanForm;
